import Box from "@mui/material/Box";
import { CategoriesFields, SocialMediaFields, SectionNames, MetaData } from "./PortalState/SectionDataMetaData";
import { utils } from "../../../lib/utils";

export const PageTabs = [
    { label: "Images", stateKey: SectionNames.ImagesTab },
    { label: "AR Page", stateKey: SectionNames.ARPageTab, metaData: MetaData[SectionNames.ARPageTab], },
    { label: "Menu Listing", stateKey: SectionNames.MenuListingTab, metaData: MetaData[SectionNames.MenuListingTab], },
    { label: "Menu Detail Popup", stateKey: SectionNames.MenuDetailsPopupTab, metaData: MetaData[SectionNames.MenuDetailsPopupTab], },
    { label: "Table Ordering Menu Layout", stateKey: SectionNames.TableOrderingMenuLayoutTab },
    { label: "Cart", stateKey: SectionNames.CartTab, metaData: MetaData[SectionNames.CartTab], },
    { label: "Checkout", stateKey: SectionNames.CheckoutTab, metaData: MetaData[SectionNames.CheckoutTab], },
    { label: "Order Success", stateKey: SectionNames.OrderSuccessTab, metaData: MetaData[SectionNames.OrderSuccessTab], },
    { label: "Order History", stateKey: SectionNames.OrderHistoryTab, metaData: MetaData[SectionNames.OrderHistoryTab], },
    { label: "Order Detail", stateKey: SectionNames.OrderDetailsTab, metaData: MetaData[SectionNames.OrderDetailsTab], },
    { label: "Add Address", stateKey: SectionNames.AddAddressTab, metaData: MetaData[SectionNames.AddAddressTab], },
    { label: "Address List", stateKey: SectionNames.AddressListTab, metaData: MetaData[SectionNames.AddressListTab], },
    { label: "Social Media", stateKey: SectionNames.socialMediaTab },
    { label: "Category Group", stateKey: SectionNames.categoryGroupsTab },
    { label: "Payment Settings", stateKey: SectionNames.PaymentSettingsTab, metaData: MetaData[SectionNames.PaymentSettingsTab], },
    { label: "Multi-Language", stateKey: SectionNames.MultiLanguageTab, metaData: MetaData[SectionNames.MultiLanguageTab], },
    { label: "Whitelist Domain", stateKey: SectionNames.WhiteListDomainTab },
];

export const COLOR_ERROR_TEXT = "Invalid Color Code";

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

export const getTabIndex = (tabName) => PageTabs.findIndex(tab => tab.stateKey === tabName);

export const checkSocialMediaFieldError = (field, value) => {
    let error;
    switch (field) {
        case SocialMediaFields.icon:
            error = value ? null : "Icon is required";
            break;
        case SocialMediaFields.name:
            error = value.trim() === "" ? "Name is required" : null;
            break;
        case SocialMediaFields.url:
            error = utils.isUrlValid(value) ? null : "A valid URL is required";
            break;
        case SocialMediaFields.iconHeight:
            error = value ? Number(value) < 40 || Number(value) > 400 ? `Icon height should be between 80 and 400` : null : null;
            break;
        case SocialMediaFields.iconWidth:
            error = value ? Number(value) < 40 || Number(value) > 400 ? `Icon width should be between 80 and 400` : null : null;
            break;
        default: return null;
    }

    return error;
}

export const checkCategoryFieldError = (field, value) => {
    let error;
    switch (field) {
        case CategoriesFields.name:
            error = value.trim() === "" ? "Name is required" : null;
            break;
        case CategoriesFields.categories:
            error = value.length === 0 ? "At least one category is required" : null;
            break;
        case CategoriesFields.imageWidth:
            error = Number(value) < 80 || Number(value) > 400 ? `Image width should be between 80 and 400` : null;
            break;
        case CategoriesFields.imageHeight:
            error = Number(value) < 80 || Number(value) > 400 ? `Image height should be between 80 and 400` : null;
            break;
        case CategoriesFields.img:
            error = value ? null : "Image is required";
            break;
        default: return null;
    }

    return error;
}



export const getDefaultErrorObject = () => {
    const errors = {};
    for (const tab of PageTabs) errors[tab.stateKey] = new Map();
    return errors
}
export const getDefaultChangeObject = () => {
    const changes = {};
    for (const tab of PageTabs) changes[tab.stateKey] = new Map();
    return changes;
}

export const isSocialMedia = (section) => section === SectionNames.socialMediaTab;
